/**
 * Server vs client CSV export sort resolution (modal download).
 * For Media Devoted | Created By Ciro Autiero
 */

import type { GenericStatsRow } from '../shared/generic-stats.types';
import type { ServerCsvExportSortConfig } from './server-sort';
import { sortGenericStatsRowsForCsvExport } from './sortRowsForCsvExport';

export function resolveServerCsvSortOverride(
  serverCsvSortConfig: ServerCsvExportSortConfig | undefined,
  exportSortField: string,
  exportSortDir: 'asc' | 'desc',
):
  | { field: string; dir: 'asc' | 'desc' }
  | null
  | undefined {
  if (!serverCsvSortConfig?.options?.length) return undefined;
  if (exportSortField !== '') {
    return { field: exportSortField, dir: exportSortDir };
  }
  return null;
}

export function resolveClientCsvExportRows(
  rows: GenericStatsRow[],
  serverCsvSortConfig: ServerCsvExportSortConfig | undefined,
  exportSortField: string,
  exportSortDir: 'asc' | 'desc',
  csvExportWorkDate: string,
): GenericStatsRow[] {
  if (serverCsvSortConfig?.options?.length && exportSortField !== '') {
    return sortGenericStatsRowsForCsvExport(
      rows,
      { field: exportSortField, dir: exportSortDir },
      csvExportWorkDate,
    );
  }
  return rows;
}
